import { Component } from '@angular/core';
import { AdvancedAmlProtectionTriggersTableComponent } from '../../advanced-aml-protection-triggers-table/advanced-aml-protection-triggers-table.component';
import { MatDialogClose, MatDialogContent, MatDialogTitle } from "@angular/material/dialog";
import { MatIcon } from "@angular/material/icon";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector: 'app-dialog-advanced-aml-protection-triggers',
    imports: [AdvancedAmlProtectionTriggersTableComponent, MatDialogClose, MatDialogContent, MatDialogTitle, MatIcon, TranslateModule],
    templateUrl: './dialog-advanced-aml-protection-triggers.component.html',
    styleUrl: './dialog-advanced-aml-protection-triggers.component.scss'
})
export class DialogAdvancedAmlProtectionTriggersComponent {
}
